 $(document).ready(function() {
  // Function to extract the variant ID from the URL
  function getVariantIdFromUrl() {
   // alert('here me');
    const urlParams = new URLSearchParams(window.location.search); 
    const variantId = urlParams.get('variant'); 
    if (variantId) {
      console.log('Variant ID from URL:', variantId);
      
      // Find the quantity and policy corresponding to the variant ID in the HTML
      const variantElement = $('.variantChange span[data-varid="' + variantId + '"]');
      const variantQty = variantElement.data('varqty');
      const variantPolicy = variantElement.data('varpolicy');
      
      // if (variantQty !== undefined) {
      //   console.log('Quantity for Variant ID ' + variantId + ':', variantQty);
      //   console.log('Policy for Variant ID ' + variantId + ':', variantPolicy);

      //   // Check if the quantity is 0 and policy is "continue"
      //   if (variantQty === 0 && variantPolicy === 'continue') {
      //     console.log('if case');
      //     $('.prerser-msg').show();  // Show the message
      //   } else {
      //     console.log('else case');
      //     $('.prerser-msg').hide();  // Hide the message
      //   }
      // } else {
      //   console.log('Quantity not found for Variant ID:', variantId);
      // }
      
      if(variantQty > 0){
        $('.soldout-msg').css('display','none');
        $('.atc_button_pdp_page').text('ADD TO CART');
        $('.atc_button_pdp_page').removeAttr('disabled');
        $('.atc_button_pdp_page').removeClass('disabled');
      }
      else{
        $('.soldout-msg').css('display','block');
        $('.atc_button_pdp_page').text('SOLD OUT');
        $('.atc_button_pdp_page').addAttr('disabled');
        $('.atc_button_pdp_page').addClass('disabled');
      }
    } 
  }

  getVariantIdFromUrl(); 

  $('.swatch label, .swatch-element label').on('click', function() { 
  setTimeout(() => {  
    console.log('Clicked function triggered');
    getVariantIdFromUrl();
  }, 500); 
});


$('.swatch[data-option-index="0"] .swatch-element').on('click', function () {
    let selectedSize = $(this).attr('data-value');

    // Find all valid flavors for the selected size
    let validFlavors = [];
    $('.variantChange span').each(function () {
        if ($(this).attr('data-option1') === selectedSize) {
            validFlavors.push($(this).attr('data-option2'));
        }
    });

    // Show/Hide flavors based on the validFlavors array
    let firstAvailableFlavor = null;
    $('.swatch[data-option-index="1"] .swatch-element').each(function () {
        let flavor = $(this).attr('data-value');
        if (validFlavors.includes(flavor)) {
            $(this).show();
            if (!firstAvailableFlavor) {
                firstAvailableFlavor = $(this); // Store the first available flavor
            }
        } else {
            $(this).hide();
        }
    });

    // Auto-select and trigger change on the first available flavor
    if (firstAvailableFlavor) {
        setTimeout(() => {
            let flavorInput = firstAvailableFlavor.find('input');
            if (flavorInput.length) {
                flavorInput.prop('checked', true).trigger('change');
                firstAvailableFlavor.trigger('click'); // Ensure parent element gets clicked
            }
        }, 100); // Small delay to allow UI updates
    }
});

// Trigger click on the selected size to filter flavors initially
setTimeout(() => {
    let selectedSizeInput = $('.swatch[data-option-index="0"] .swatch-element input:checked');
    if (selectedSizeInput.length) {
        selectedSizeInput.parent().trigger('click');
    }
}, 100);

   
    // $('.swatch[data-option-index="0"] .swatch-element').on('click', function () {
    //     let selectedSize = $(this).attr('data-value');
        
    //     // Find all valid flavors for the selected size
    //     let validFlavors = [];
    //     $('.variantChange span').each(function () {
    //         if ($(this).attr('data-option1') === selectedSize) {
    //             validFlavors.push($(this).attr('data-option2'));
    //         }
    //     });

    //     // Show/Hide flavors based on the validFlavors array
    //     $('.swatch[data-option-index="1"] .swatch-element').each(function () {
    //         let flavor = $(this).attr('data-value');
    //         if (validFlavors.includes(flavor)) {
    //             $(this).show();
    //         } else {
    //             $(this).hide();
    //         }
    //     });
    // });

    // // Trigger click on the selected size to filter flavors initially
    // $('.swatch[data-option-index="0"] .swatch-element input:checked').parent().trigger('click');
 



});

$(document).ready(function(){

setTimeout(function(){
    $("img.lazyload").lazyload();
  }, 1000);
  
  $('.related-bundle-products-wrap').slick({
    dots: false,
    infinite: true,
    fade: true
  });

  function upsell_slider() {
    $('.upsell-product_wrap').slick({
      dots: true,
      arrows:false,
      infinite: true,
      fade: true
    });
  }

  // upsell_slider()

  $('.head_of_team-right').slick({
  dots: false,
  infinite: false,
    arrows:true,
  speed: 300,
  slidesToShow: 2,
  slidesToScroll: 2,
  responsive: [
    {
      breakpoint: 1199,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2,
        infinite: true,
        dots: false
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
 
  ]
});
				


  

  $('.search_btn').click(function(){
    $(this).parents('.custom_search_bar').find('.search-overlay').slideDown();
  })
    $('.closebtn').click(function(){
    $(this).parents('.search-overlay').slideUp();
  })
  
  jQuery(".video-btn").on("click",function(e){
    var o=jQuery(".video-container iframe").attr("data-src");
    jQuery(".video-container iframe").attr("src",o);
    e.preventDefault();
    jQuery(".video-wrapper-container").fadeIn()
  });
  
  jQuery(".close-btn").click(function(){
    jQuery(".video-container iframe").attr("src","");
    jQuery(".video-wrapper-container").fadeOut()
  });
  $('.upsell-product_wrap .add_to_cart ').on('click', function(){
   $(this).parent('.upsell-product_grid').addClass('hidden');  
  });


  $('.klviyo_subscribe_success').click(function(){
    $(this).hide();
})

  
  //product page sticky ATC bar get scroll position code
  window.addEventListener("scroll", (event) => {
      let scrollPosition = window.scrollY;
    if(scrollPosition > 1200) {
     $('#StickyPlusBar').addClass("stickyShow");
    }
    else {
      $('#StickyPlusBar').removeClass("stickyShow"); 
    }
  });

  //product page sticky ATC bar quantity box plus minus code
    $('#stickyAddToCart_Plus_btn').click(function () {
        $(this).prev().val(+$(this).prev().val() + 1);
    });
    $('#stickyAddToCart_Minus_btn').click(function () {
      if ($(this).next().val() > 1) {
        if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
      }
    });

  $('.StickyPlusBar--Select select').on('change', function(){
    var variant_id = $( ".StickyPlusBar--Select select option:selected" ).data('variant_id');
    $('.StickyPlusBar--Btn-Text form #variant_id').val(variant_id);
  });
  $('#stickyAddToCart_btn_wrap button').on('click', function(){
    var sticky_qty = $(this).parent('#stickyAddToCart_btn_wrap').children('#qty_num').val();
    $('.StickyPlusBar--Btn-Text form #quantity').val(sticky_qty);
  });

  // product page image slider
   $('.product_main-img').slick({
     infinite: false,
     slidesToShow: 1,
     slidesToScroll: 1,
     arrows: false,
     adaptiveHeight: true,
     fade: true,
     asNavFor: '.product_thumbnail-img'
  });
  $('.product_thumbnail-img').slick({
    infinite: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    asNavFor: '.product_main-img',
    dots: false,
    arrows: true,
    focusOnSelect: false
  });

  function variant_image_change() {
    let url = new URL(window.location.href);
    let searchParams = new URLSearchParams(url.search);
    var selected_variant_param = searchParams.get('variant');
    if(selected_variant_param === null ) {
      var filterClass = $('.multi_select :selected').val();
      if(typeof  filterClass === 'undefined' ) {
        $('.product_main-img, .product_thumbnail-img').slick('slickUnfilter');
      }
      else{
        // $('.product_main-img, .product_thumbnail-img').slick('slickUnfilter');
        $('.product_main-img, .product_thumbnail-img').slick('slickUnfilter');
        $('.product_main-img, .product_thumbnail-img').slick('slickFilter', '.product_variant-variant_ID--'+filterClass);
        $('.product_main-img, .product_thumbnail-img').slick('refresh');
      }
    }
    else {
      var filterClass = selected_variant_param;
     $('.product_main-img, .product_thumbnail-img').slick('slickUnfilter');
      $('.product_main-img, .product_thumbnail-img').slick('slickFilter', '.product_variant-variant_ID--'+filterClass);
      $('.product_main-img, .product_thumbnail-img').slick('refresh');
    }
      setTimeout(function(){
        $('.product_main-img, .product_thumbnail-img').slick('slickGoTo', 0);
      }, 500);
    
  }
  variant_image_change()
  $('.single-option-selector').on('change', function(){ 
    variant_image_change()
  });
  $('.swatch_options .swatch-element label').on('click', function(){
    setTimeout(function() {
      variant_image_change()
    }, 500);
    
  });
  $('.product_thumbnail-img .product-image').click(function(){
    var slider_index = $(this).data('slick-index');
    setTimeout(function(){
    $('.product_main-img').slick('slickGoTo', slider_index);
      }, 500);
  });

  $('.add_to_cart').click(function(){
    setTimeout(function(){
    $( ".cart_upsell-products_wrap" ).load(window.location.href + " .cart_upsell-products_wrap" );
      upsell_slider()
    }, 2500);
  });
  $(document).on('click', '.js-change-quantity', function(){
    setTimeout(function(){
     $( ".cart_drawer-wrapper" ).load(window.location.href + " .cart_drawer-wrapper");
    }, 2000);
  });

  // collection page description show more show less code.
$('.readmore').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'block';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'none';
});
$('.readless').click(function (event) {
  event.preventDefault();
  var descriptionFull = document.querySelector('.product-description-full');
  descriptionFull.style.display = 'none';
  var descriptionShort = document.querySelector('.product-description-short');
  descriptionShort.style.display = 'block'; 
  window.scrollTo({top: 110, behavior: 'smooth'});
});
$('.faq-questions').click(function(){
  $('.faq-questions-answer-wrapper').removeClass('active');
  $(this).parent('.faq-questions-answer-wrapper').addClass('active');
    $('.faq-answer').slideUp('slow');
    $(this).next('.faq-answer').slideDown('slow');
});
  
// product page magnifying glass js begains
  $('.image-zoom')
    .wrap('<span style="display:inline-block"></span>')
    .css('display', 'block')
    .parent()
    .zoom({
      url: $(this).find('img').attr('data-zoom')
    });

   $('.sec:first-child').addClass('firstClm');
    $('.tab li.tab-list a').click(function(){
        $('.tab li.tab-list a').removeClass('active');
        $(this).parents('ul.tab').siblings().children().removeClass('firstClm');
        $(this).addClass('active');
        var tagname = $(this).data('tag');
        $('.tab_cnt div.sec').removeClass('active_sec').addClass('hide_sec');
        $('#'+tagname).removeClass('hide_sec').addClass('active_sec');
    });

  // show hide the search bar on header on click of outside of search bar
    var mouse_is_inside = false;
    $('.search__form').hover(function(){
        mouse_is_inside = true; 
    }, 
    function(){
        mouse_is_inside = false; 
    });
    $(".search-overlay").click(function(){
        if(! mouse_is_inside) $('.search-overlay').slideUp(500);
    });

  // E-book landing page Klaviyo subscribe API call
  $('.ebook_klviyo_subscribe_btn').click(function(event){
        event.preventDefault();
        var name = $(this).parents('.ebook_contact_form').find('.name_field').val();
        var customer_email = $(this).parents('.ebook_contact_form').find('.email_field').val();
        var customer_mobile = $(this).parents('.ebook_contact_form').find('.mobile_field').val();
        var ctEmail = customer_email.length;
          var customer_name = name.length;
        //var ctMob = customer_mobile.length;
      //  var country_isd_code = $('.selected_country a > span > span:nth-child(3)').text();
        if (ctEmail > 0 && customer_name > 0){
        var settings = {
          "url": "https://manage.kmail-lists.com/ajax/subscriptions/subscribe",
          "method": "POST",
          "timeout": 0,
          "headers": {
          "Content-Type": "application/x-www-form-urlencoded"
          },
          "data": {
            "g": "VCdtcG",
            "$first_name": name,
            "$email": customer_email,
            "sms_consent": "true",
            "is_subscribed": true,
            "subscribe_for_newsletter": true,
            "$phone_number": customer_mobile,
            "$fields": "sms_consent, $consent",
            "$consent": "['sms', 'email']",
            "$source": "Creatine E-book landing page"
          }
          };
            setTimeout(function() {
              $.ajax(settings).done(function (response) {
               window.location.href = '/pages/ebook-thank-you'
             });  
            }, 1000);  
          }
          else {
            alert("Name and Email field can't be blank");
          }
          });
    setTimeout(function() {
      var cart_counter = $('.fixed_cart_icon a .cart_count').text();
      var cart_count = parseInt(cart_counter);
      console.log(cart_count);
      console.log(typeof cart_count);
      console.log(typeof cart_counter);
    }, 2000);  
  $(document).on('click', '.open_cart_drawer', function() {
     $('body').addClass('cart_drawer_open'); 
  });
  var url_string = window.location.href; 
  var url = new URL(url_string);
  
  var openCart = url.searchParams.get("openCart");
    if(openCart == 'true') {
      $('body').addClass('cart_drawer_open'); 
    }
  
  var url_contact_param = url.searchParams.get("contact_posted");
  if (url_contact_param == 'true') {
    var thanksPopup = document.getElementById('wholesale-popup');
    thanksPopup.style.display = "flex";
       document.body.style.overflow = 'hidden'
    $('form.contact-form').addClass('formSubmitted');
  } 
     // document.querySelector('.loading-indicator').style.display = 'none';
    //  document.querySelector('.page--template_product .product-images-wrap').style.display = 'block';
});
document.addEventListener('DOMContentLoaded', () => {
    // Hide the loading indicator
    const loadingIndicator = document.querySelector('.loading-indicator');
    if (loadingIndicator) {
        loadingIndicator.style.display = 'none';
    }

    // Show the product images wrap
    const productImagesWrap = document.querySelector('.page--template_product .product-images-wrap');
    if (productImagesWrap) {
        productImagesWrap.style.display = 'block';
    }
});



 document.addEventListener('DOMContentLoaded',function(){
   if (window.location.pathname === '/pages/wholesale-landing-page') {
    var popup = document.getElementById('wholesale-popup');
    var openpopup = document.querySelectorAll('.wholesale-apply-popup');
    var closepopup = document.getElementById('closepopup');
   openpopup.forEach(function(btn){
     btn.addEventListener('click', function(){
       popup.style.display = "flex";
       document.body.style.overflow = 'hidden'
     })
   })
   closepopup.addEventListener('click',function(e){ 
      popup.style.display = "none";
     document.body.style.overflow = 'auto'
   })
   }
  })



 
  // document.addEventListener('DOMContentLoaded', function () {
  //   // Find the promo banner by its class
  //   const promoBanner = document.querySelector('.promo-banner');
  //   const redirectUrl = "https://www.musclefeast.com/collections/all-products"; // Redirect URL
  //   const couponCode = promoBanner.getAttribute('data-promo');

  //   if (promoBanner) {
  //     promoBanner.addEventListener('click', function (event) {
  //       event.preventDefault(); // Prevent default click behavior

  //       // Copy coupon code to clipboard
  //       const tempInput = document.createElement('input');
  //       tempInput.value = couponCode;
  //       document.body.appendChild(tempInput);
  //       tempInput.select();
  //       document.execCommand('copy');
  //       document.body.removeChild(tempInput);

  //       // Display the message
  //       let message = document.createElement('div');
  //       message.textContent =
  //         "The coupon code "+ couponCode + " has been copied to your clipboard. Just paste it at checkout and save.";
  //       message.style.cssText = `
  //         margin-top: 10px;
  //         color: #4CAF50;
  //         font-size: 14px;
  //         text-align: center;
  //       `;

  //       // Insert the message after the promo banner
  //       promoBanner.parentNode.insertBefore(message, promoBanner.nextSibling);

  //       // Remove the message after 3 seconds
  //       setTimeout(() => {
  //         message.remove();
  //       }, 3000);

  //       // Redirect after 1 second
  //       setTimeout(function () {
  //         window.location.href = redirectUrl;
  //       }, 1000); // 1000ms = 1 second
  //     });
  //   }
  // }); 

